import React from "react";
import { medicalInvoiceData } from "../data/medicalInvoiceData";

const MedicalTemplate = () => {
  const company = medicalInvoiceData?.company || {};
  const invoice = medicalInvoiceData?.invoice || {};
  const client = medicalInvoiceData?.client || {};
  const items = Array.isArray(medicalInvoiceData?.items) ? medicalInvoiceData.items : [];
  const gstRate = medicalInvoiceData?.gstRate || 0;

  const subtotal = items.reduce((sum, item) => sum + (Number(item.rate) || 0), 0);
  const gstAmount = (subtotal * gstRate) / 100;
  const total = subtotal + gstAmount;

  const compactGreen = "bg-[#7DB164]";
  const lightGreen = "bg-[#E8F3E5]";

  return (
    <div className="bg-white p-6 text-gray-800 font-sans mx-auto shadow-sm">
      <div className="flex justify-between mb-4 items-start">
        <div>
          <h1 className="text-xl font-bold text-[#2D5A27]">{company.name || "Company Name"}</h1>
          {company.tagline && <p className="text-xs font-medium text-[#7DB164] italic">{company.tagline}</p>}
          {company.address && <p className="text-[10px] text-gray-500 mt-1 leading-tight">{company.address}</p>}
          {company.phone && <p className="text-[10px] text-gray-500">{company.phone}</p>}
          {company.email && <p className="text-[10px] text-gray-500">{company.email}</p>}
        </div>
        <div className="text-right text-xs font-bold">
          <p>Invoice #: {invoice.number || "-"}</p>
          <p>Date: {invoice.date || "-"}</p>
          <p>Due Date: {invoice.dueDate || "-"}</p>
          <p>Prepared by: {invoice.preparedBy || "-"}</p>
          <p>Payment Terms: {invoice.paymentTerms || "-"}</p>
        </div>
      </div>

      {/* Client Info */}
      <div className="grid grid-cols-2 gap-4 mb-2">
        <div className="border-l-2 border-orange-500 pl-2 py-1 text-[10px]">
          <p className="font-bold uppercase">Client:</p>
          <p className="text-sm font-bold">{client.name || "-"}</p>
          <p className="text-[10px] text-gray-600">{client.address || "-"}</p>
        </div>
      </div>

      {/* Table Header */}
      <div className={`${compactGreen} text-white grid grid-cols-4 text-[10px] font-bold uppercase`}>
        <div className="border-r border-white/20 p-1 text-center">Months</div>
        <div className="border-r border-white/20 p-1 text-left">Description</div>
        <div className="border-r border-white/20 p-1 text-center">Unit Price (₹)</div>
        <div className="p-1 text-center">Line Total (₹)</div>
      </div>

      {/* Table Rows */}
      {items.length > 0 ? (
        items.map((item, idx) => (
          <div key={idx} className={`grid grid-cols-4 text-[10px] border border-t-0 border-gray-300 ${idx % 2 === 0 ? "bg-white" : lightGreen}`}>
            <div className="border-r border-gray-300 p-1 text-center">{item.months || 1}</div>
            <div className="border-r border-gray-300 p-1">{item.desc || "-"}</div>
            <div className="border-r border-gray-300 p-1 text-center">{Number(item.rate || 0).toFixed(2)}</div>
            <div className="p-1 text-right">{Number(item.rate || 0).toFixed(2)}</div>
          </div>
        ))
      ) : (
        <div className="grid grid-cols-4 text-[10px] border border-gray-300 bg-white">
          <div className="border-r border-gray-300 p-1 text-center">-</div>
          <div className="border-r border-gray-300 p-1">No items added</div>
          <div className="border-r border-gray-300 p-1 text-center">-</div>
          <div className="p-1 text-right">-</div>
        </div>
      )}

      {/* Footer totals */}
      <div className="flex justify-end text-xs font-bold mt-2">
        <div className="w-48 space-y-1">
          <div className="flex justify-between"><span>Subtotal</span><span>₹ {subtotal.toFixed(2)}</span></div>
          <div className="flex justify-between"><span>GST ({gstRate}%)</span><span>₹ {gstAmount.toFixed(2)}</span></div>
          <div className="flex justify-between text-lg"><span>Total</span><span>₹ {total.toFixed(2)}</span></div>
        </div>
      </div>

      <div className="border border-orange-500 p-2 text-[10px] mt-3">
        <p className="mb-1"><span className="font-bold">Invoice prepared by:</span> {invoice.preparedBy || "-"}</p>
        <p className="italic text-gray-500 text-[9px]">This invoice is for medical aesthetics services. Payment due upon receipt.</p>
        <div className="flex items-center gap-2 mt-2">
          <p className="font-bold">Signature:</p>
          <div className="flex-grow border-b border-gray-400 h-4"></div>
        </div>
      </div>

      <p className="text-center font-bold text-green-700 mt-2 italic text-[10px]">Thank you for choosing {company.name || "our services"}!</p>
    </div>
  );
};

export default MedicalTemplate;
